import type {
  BrokerLeadsResponse,
  BrokerPoliciesResponse,
  BrokerQuote,
  BrokerQuotesResponse,
  ConsultPolicyResponse,
} from '../types/brokerDashboard';
import baseApi from './baseApi';

interface GetBrokerQueryParams {
  brokerBusinessUnitId?: number;
  paginationModel?: string;
  filterModel?: string;
  sortModel?: string;
}

interface GetBrokerLeadsParams {
  brokerBusinessUnitId?: number;
  paginationModel?: string;
}

interface GetBrokerLeadQuotesParams {
  leadId: number;
  brokerBusinessUnitId?: number;
}

const brokerDashboardApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getBrokerQuotes: build.query<BrokerQuotesResponse, GetBrokerQueryParams>({
      query: (params) => ({
        url: '/broker-dashboard/quotes',
        method: 'GET',
        params,
      }),
    }),
    getBrokerLeads: build.query<BrokerLeadsResponse, GetBrokerLeadsParams>({
      query: (params) => ({
        url: '/broker-dashboard/leads',
        method: 'GET',
        params,
      }),
    }),
    getBrokerLeadQuotes: build.query<BrokerQuote[], GetBrokerLeadQuotesParams>({
      query: (params) => ({
        url: '/broker-dashboard/lead-quotes',
        method: 'GET',
        params,
      }),
    }),
    getBrokerPolicies: build.query<BrokerPoliciesResponse, GetBrokerQueryParams>({
      query: (params) => ({
        url: '/broker-dashboard/policies',
        method: 'GET',
        params,
      }),
    }),
    consultPolicy: build.mutation<ConsultPolicyResponse, { policyId: number }>({
      query: (body) => ({
        url: '/bci-seguros-veritas/consult-policy',
        method: 'POST',
        body,
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetBrokerQuotesQuery,
  useGetBrokerLeadsQuery,
  useGetBrokerLeadQuotesQuery,
  useGetBrokerPoliciesQuery,
  useConsultPolicyMutation,
} = brokerDashboardApi;
